/* A hidden mechanism film must not keep playing after another tab is selected. */
document.addEventListener('ss:tab', event => {
  if (!event.target.matches('.ss-explain__layout')) return;
  event.target.querySelectorAll('[role="tabpanel"][hidden] video').forEach(video => video.pause());
});
